// extracted by mini-css-extract-plugin
module.exports = {"root":"_2y7rR","link":"Tj7s6"};